
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/philosophy",
      function () {
        return require("private-next-pages/company/philosophy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/philosophy"])
      });
    }
  